var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}")), /*#__PURE__*/React.createElement("title", null, "data-2"), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 12,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 7,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 24,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Path_",
    "data-name": "<Path>",
    x: 24,
    y: 24,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    className: "cls-1",
    width: 32,
    height: 32
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogData);
export default __webpack_public_path__ + "static/media/log-data.7c0a091d2883b2a5f73d85cf0fd2296e.svg";
export { ForwardRef as ReactComponent };